/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import onnxTest_IconURL from '../RAISE_Logo.png';
import onnxTest_InsetIconURL from '../PRG_Logo.png';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Onnx Example"
        description="name for the Onnx Example extension"
        id="extension.onnxTest.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="A demonstration that an onnx model can be used (not exciting, nor educationally valuable)"
        description="description for the Onnx Example extension"
        id="extension.onnxTest.description"
    />
  ),
	iconURL: onnxTest_IconURL,
	insetIconURL: onnxTest_InsetIconURL,
	tags: ["PRG Internal"],
	featured: true,
	extensionId: 'onnxTest',
}